module.exports = __webpack_public_path__ + "media/invest/institutional-strategy-7b5fe706.png";